import request from '@/request/request'

export function listDoorEvents(query) {
    return request({
        url: '/api/equipment-server/door/events',
        method: 'get',
        params: query
    })
}

export function getDoorMap() {
    return request({
        url: '/api/equipment-server/door/doorMap',
        method: 'get'
    })
}

export function getDoorList() {
    return request({
        url: '/api/equipment-server/door/doorList',
        method: 'get'
    })
}
